import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table12 from "./components/Factors/Table/Table12";
import Table13 from "./components/Factors/Table/Table13";
import { useState } from "react";

const PageG4 = ({ reload }) => {
    const [damaneErtebatiScore, setDamaneErtebatiScore] = useState("")
    const [masouliatMoghararatScore, setMasouliatMoghararatScore] = useState("")
    return (
        <>
            <Page pageNumber={28}>
                <HeaderFactors
                    numberFactors="عامل هشتم"
                    titelFactors="ارتباطات"
                    maxValue="40"
                    jsValue={damaneErtebatiScore}
                />
                <ExplainFactor
                    text="مسئولیت در برقراری ارتباط با سازمانها و واحدهای داخلی شرکت ویا سازمانها وموسسات به منظور کسب
                    همکاری وموافقت ، تبادل نظر ومشاوره یا تبادل اطالعات است."
                />
                <Table12 damaneErtebatiScore={damaneErtebatiScore} setDamaneErtebatiScore={setDamaneErtebatiScore} reload={reload}/>
                <SpaceBetweenTables />
                <HeaderFactors
                    numberFactors="عامل نهم"
                    titelFactors="مسئوليت مقررات، روش ها و سيستم ها"
                    maxValue="30"
                    jsValue={masouliatMoghararatScore}
                />
                <ExplainFactor
                    text="مسئولیت شغل در قبال توضیح، تفسیر، وضع یا بکارگیری واجرای آیین نامه ها ، دستورالعمل ها، شیوه نامه
                    ها، سیستم ها ورویه ها"
                />
                <Table13 masouliatMoghararatScore={masouliatMoghararatScore} setMasouliatMoghararatScore={setMasouliatMoghararatScore} reload={reload}/>
            </Page>
        </>
    );
};

export default PageG4;
